import React, { Suspense, lazy } from 'react';
import classNames from 'classnames';
import css from './InvoiceDownloadButton.module.css';

// Lazy-load to avoid SSR issues with @react-pdf/renderer
const PDFDownloadLink = lazy(() =>
  import('@react-pdf/renderer').then(mod => ({ default: mod.PDFDownloadLink }))
);
const TransactionInvoice = lazy(() => import('./TransactionInvoice'));

/**
 * InvoiceDownloadButton — renders a PDF download link for a transaction.
 *
 * @param {Object} props
 * @param {Object} props.transaction
 * @param {string} [props.marketplaceName]
 * @param {string} [props.marketplaceUrl]
 * @param {string} [props.className]
 * @param {string} [props.label]
 */
const InvoiceDownloadButton = ({
  transaction,
  marketplaceName,
  marketplaceUrl,
  className,
  label = 'Download Receipt',
}) => {
  if (!transaction?.id?.uuid) return null;

  const filename = `receipt-${transaction.id.uuid}.pdf`;

  return (
    <Suspense fallback={<span className={classNames(css.root, className, css.loading)}>{label}</span>}>
      <PDFDownloadLink
        className={classNames(css.root, className)}
        document={
          <TransactionInvoice
            transaction={transaction}
            marketplaceName={marketplaceName}
            marketplaceUrl={marketplaceUrl}
          />
        }
        fileName={filename}
      >
        {({ loading }) => (loading ? `${label}...` : label)}
      </PDFDownloadLink>
    </Suspense>
  );
};

export default InvoiceDownloadButton;
